import SelectObject from "../../assets/SelectObject";
import {Button} from "@vkontakte/vkui";
import {Icon24Dropdown} from "@vkontakte/icons";
import React from "react";
import * as constants from "../../assets/constants";
import SalePoint from "./salePoint";


class MallSelectObject extends SelectObject {

    renderCreateForm() {
        const base_url = constants.DEBUG ? constants.base_url_stage : constants.base_url_prod
        return <SalePoint
            no_reload_klient
            current_user={this.state.current_user}
            base_url={base_url}
            item={this.state.current_object}
            change={this.editCurrentSalePoint}
            hideForm={() => this.closeList()}
            onCreate={(value) => {
                this.setState({current_object: value})
                window.postMessage({type: 'newMallCreated', value})
                window.postMessage('closeSelectObject' + this.guid)
            }}
        />
    }

    createAction() {
        super.createAction()

        const value = {
            //id: -1,
            klient_id: null,
            mall_id: null,
            isMall: 1,
            comment: '', info: ''
        }
        this.setState({current_object: value})

        window.postMessage({
            type: 'setCurrentMall',
            value
        })
    }

    editCurrentSalePoint = (e, fieldName) => {
        const {current_object} = this.state
        ///console.log(e)
        if (e.unrestricted_value !== undefined) {
            current_object.dadata_object = e
            current_object.full_address = e.value
        } else {
            current_object[fieldName] = e.currentTarget.value
        }
        this.setState({current_object})
    }


    renderButton = (styleDefault) => {

        const {current_object} = this.state

        return <div style={{display: 'flex'}}><Button size={this.props.size ? this.props.size : "l"}
                                                      disabled={this.props.disabled ?? false}
                                                      mode={this.props.mode ? this.props.mode : "primary"}
                                                      className={this.props.className}
                                                      after={<Icon24Dropdown/>}
                                                      style={{...styleDefault, ...this.props.style}}
                                                      onClick={() => this.showList()}
                                                      before={this.props.icon ? this.props.icon : ''}
                                                      selected={current_object.id != undefined}
                                                      expandable

        >
            {current_object.id != undefined || current_object.uid != undefined ?
                (<b>{`${current_object.title} `}</b>) :
                (this.props.unselect_title ? this.props.unselect_title : 'Не указан')}
            {current_object.id != undefined || current_object.uid != undefined ?
                <small>{current_object ? current_object.full_address : ''}</small> : ''}
        </Button>
            {this.props.addon ?? ''}
        </div>
    }

}

export default MallSelectObject